import "./Projects.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  PageSetting,
  ProjectRaw,
  ProjectsMessages,
  Query,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/projects/get-projects-actions";
import { findById } from "../../../../controllers/store/actions/projects/update-projects-actions";
import { remove } from "../../../../controllers/store/actions/projects/delete-project-action";
import UpdateProjectModal from "../../../components/Forms/Modal/Projects/UpdateProject";
import { clear } from "../../../../controllers/store/actions/projects/create-project-action";
import NewProjectModal from "../../../components/Forms/Modal/Projects/NewProject";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;
const formatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "COP", // Cambia a 'USD', 'COP', etc., según la moneda que necesites.
});
const query: Query = { filter: {} };
const Groups: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const projectsState = useSelector((state: any) => state.projects);
  const updatedProjectState = useSelector((state: any) => state.updatedProject);
  const deletedProjectState = useSelector((state: any) => state.deletedProject);
  const createdProjectState = useSelector((state: any) => state.createdProject);
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const columns: TableProps<ProjectRaw>["columns"] = [
    {
      title: "Nombre del proyecto",
      dataIndex: "titulo_proyecto",
      key: "titulo_proyecto",
    },
    {
      title: "Descripción Detallada",
      dataIndex: "descripcion_detallada",
      key: "descripcion_detallada",
    },
    {
      title: "Área de conocimiento",
      dataIndex: "area_de_conocimiento",
      key: "area_de_conocimiento",
    },

    {
      title: "Especialidad de conocimiento",
      dataIndex: "especialidad_de_conocimiento",
      key: "especialidad_de_conocimiento",
    },

    {
      title: "Gran área del conocimiento",
      dataIndex: "gran_area_de_conocimiento",
      key: "gran_area_de_conocimiento",
    },
    {
      title: "Estado del avance del proyecto",
      dataIndex: "estado_proyecto",
      key: "estado_proyecto",
    },
    {
      title: "Presupuesto estimado",
      dataIndex: "presupuesto_estimado",
      key: "presupuesto_estimado",
      render(value, record, index) {
        return formatter.format(parseInt(value || 0));
      },
    },
    {
      title: "Tiempo de ejecuion estimado",
      dataIndex: "tiempo_de_ejecucion_estimado",
      key: "tiempo_de_ejecucion_estimado",
    },
    {
      title: "Ciudad",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: ProjectRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: ProjectsMessages.Title,
                content: ProjectsMessages.ProjectsDeleteSuccessMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreateProjectMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: ProjectsMessages.Title,
      description: ProjectsMessages.ProjectCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeleteProjectMessage = () => {
    api["success"]({
      key: 1,
      message: ProjectsMessages.Title,
      description: ProjectsMessages.ProjectsDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdateProjectMessage = () => {
    api["success"]({
      key: 1,
      message: ProjectsMessages.Title,
      description: ProjectsMessages.ProjectsUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    //query.filter.user = `&filter[user_created][_eq]=${userState.me.id}&deep=true`;
    dispatch(find(1, pageSize, { filter: {} }));
    setInitialDataLoaded(true);
  }, [pageSize]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  return (
    <Layout className="projects-layout">
      {contextHolder}
      {createdProjectState.project ? showCreateProjectMessageSuccess() : null}
      {deletedProjectState.removed ? showDeleteProjectMessage() : null}
      {updatedProjectState.updatedProject ? showUpdateProjectMessage() : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="projects-content">
        <Card className="projects-card">
          <NewProjectModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateProjectModal
            project={updatedProjectState.project}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />

          {!initialDataLoaded && projectsState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={<span>No tienes proyectos aún</span>}
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar proyectos
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <h1 className="heading-content-title">Proyectos</h1>
              <br />
              <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Agregar proyecto
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={projectsState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 2000 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      projectsState.meta?.total_count ||
                      projectsState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={projectsState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Groups;
